import React from 'react';
import ResourceEditProvider from 'js/components/ResourceEditProvider';
import useResourceEditProvider from 'js/components/ResourceEditProvider/useResourceEditProvider';
import { BannerDescription } from 'new/elements/BannerDescription';
import { RESOURCE_TYPE_SOURCE } from 'js/constants/resourceTypes';
import { CONNECTOR_CODE_SQL_RUNNER } from 'js/constants/connectionCategories';
import { SqlAutomationsPipelinesContainer } from 'js/components/pipelines/PipelinesContainer';

function ViewSQLAutomationsContent(): React.ReactElement {
  const { setAction } = useResourceEditProvider();

  const handleNewAutomation = () => {
    setAction({
      resource: RESOURCE_TYPE_SOURCE,
      type: 'create',
      queryParams: {
        selectedConnection: CONNECTOR_CODE_SQL_RUNNER,
      },
    });
  };

  return (
    <>
      <BannerDescription
        title="SQL Automations"
        description="Manage and run SQL automations here. More content coming soon."
        actionTitle="New Automation"
        onClick={handleNewAutomation}
      />
      <SqlAutomationsPipelinesContainer
        withHeader={false}
        disableProjectView
        resetListingOnMount={false}
      />
    </>
  );
}

export function ViewSQLAutomations(): React.ReactElement {
  return (
    <ResourceEditProvider>
      <ViewSQLAutomationsContent />
    </ResourceEditProvider>
  );
}
